import { primary, secondary, danger } from './contained.js';
import { primary as primary$1, secondary as secondary$1, danger as danger$1 } from './outlined.js';
import { primary as primary$2, secondary as secondary$2, danger as danger$2 } from './ghost.js';
import { primary as primary$3, secondary as secondary$3, danger as danger$3 } from './icon.js';
import { primary as primary$4, secondary as secondary$4, danger as danger$4 } from './contained_icon.js';

var token = {
  primary: {
    contained: primary,
    outlined: primary$1,
    ghost: primary$2,
    ghost_icon: primary$3,
    contained_icon: primary$4
  },
  secondary: {
    contained: secondary,
    outlined: secondary$1,
    ghost: secondary$2,
    ghost_icon: secondary$3,
    contained_icon: secondary$4
  },
  danger: {
    contained: danger,
    outlined: danger$1,
    ghost: danger$2,
    ghost_icon: danger$3,
    contained_icon: danger$4
  }
};

export { token };
